import React, { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { ContactInstrumentActionIds } from 'types/atoms/atom.contacts'
import { contactInstrumentActionAtom } from './atoms/contactAtoms'
import { ContactFiatInstrumentForm } from './components/FiatInstrument/FiatInstrument'
import { ContactInstrumentDecision } from './ContactInstrumentDecision'
import { ContactInstrumentForm } from './ContactInstrumentForm'

interface ContactInstrumentsSheetProps {
  isSheetOpen: boolean
  isNestedSheet?: boolean
}

export const ContactInstrumentsSheet = ({
  isSheetOpen,
  isNestedSheet = false,
}: ContactInstrumentsSheetProps) => {
  const contactInstrumentAction = useAtomValue(contactInstrumentActionAtom)
  const { onBack, onClose, header, subHeader } = contactInstrumentAction || {}

  const sheetContent = useMemo(() => {
    switch (contactInstrumentAction?.actionId) {
      case ContactInstrumentActionIds.CONTACT_INSTRUMENT_DECISION:
        return <ContactInstrumentDecision />
      case ContactInstrumentActionIds.INSTRUMENT:
        return <ContactInstrumentForm />
      case ContactInstrumentActionIds.FIAT_INSTRUMENT:
        return <ContactFiatInstrumentForm />
      default:
        return null
    }
  }, [contactInstrumentAction])

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={onClose}
      subHeader={subHeader}
      isNestedSheet={isNestedSheet}
    >
      {sheetContent}
    </Sheet>
  )
}
